<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            class="shrink mr-2"
            contain
            src="./assets/english_logo.jpg"
            transition="scale-transition"
            width="40"
          />
        </router-link>
      </div>

      <v-toolbar-title>
        <router-link to="/"></router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="!isLoggedIn()">
        <v-btn text large to="/signin">ログイン</v-btn>
        <v-btn text large to="/signup">会員登録</v-btn>
      </template>
      <template v-if="isLoggedIn() && isTestMode()">
        <v-icon
          size="28"
          class="ml-2"
          color="white lighten-1"
          @click="showTestModeHelp()"
          >mdi-help-circle</v-icon
        >
      </template>
      <template v-if="isLoggedIn() && !isTestMode()">
        <v-btn @click="displayLogoutDialog" text large>ログアウト</v-btn>
      </template>

      <logout-dialog
        v-on:close="closeLogoutDialog"
        v-model="logoutDialog"
      ></logout-dialog>
      <help-dialog
        v-on:close="closeHelpDialog"
        v-model="helpDialog"
      ></help-dialog>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import LogoutDialog from "./components/LogoutDialog";
import HelpDialog from "./components/HelpDialog";

export default {
  name: "App",
  components: {
    LogoutDialog,
    HelpDialog,
  },
  methods: {
    isLoggedIn() {
      return this.$store.getters.uid != null;
    },
    isTestMode() {
      return this.$router.currentRoute.name == "word-note-test-mode";
    },
    displayLogoutDialog() {
      this.logoutDialog = true;
    },
    closeLogoutDialog() {
      this.logoutDialog = false;
    },
    showTestModeHelp() {
      this.helpDialog = true;
    },
    closeHelpDialog() {
      this.helpDialog = false;
    },
  },
  data: () => ({
    logoutDialog: false,
    helpDialog: false,
  }),
};
</script>

<style scoped></style>
